
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 19 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.1 13.9v2.4c0 .9-.7 1.6-1.6 1.6h-.2c-2.5-.3-4.8-1.1-6.9-2.5-1.9-1.2-3.6-2.9-4.8-4.8-1.3-2-2.1-4.4-2.4-6.9 0-.9.6-1.6 1.5-1.7h2.5c.8 0 1.5.6 1.6 1.4.1.8.3 1.5.6 2.3.2.5.1 1.1-.4 1.6l-1 1c1.1 2 2.8 3.7 4.8 4.8l1-1c.4-.4 1.1-.6 1.7-.4.7.3 1.5.5 2.2.6.9.1 1.5.8 1.4 1.6zM17.9 1.6l-4.8 4.8-2.2-2.2","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    